export class GerenciadorCookieSvaut {

    public static LimparCookieRedirecionamento() {

      const date = new Date();

      // Set it expire in -1 days
      date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

      // Set it
      document.cookie = "UrlProjeto=; expires="+date.toUTCString()+"; path=/";
    }

    public static DefinirCookieRedirecionamento(urlRedirecionamento: string) {

        // --- SALVA NO COOKIE A URL FINAL DE SUCESSO ---
      let currentUrlPath = window.location.origin + window.location.pathname;

      if(currentUrlPath == null ||currentUrlPath == undefined){
              currentUrlPath =  window.location.href
      }

      const encodedUrl = window.btoa(urlRedirecionamento);
      const urlProjet = window.btoa("UrlProjeto");
      document.cookie = `${urlProjet}=${encodedUrl}; domain=sefaz.ba.gov.br; path=/`;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/svaut/gerenciador-cookie-svaut.ts